import { render, staticRenderFns } from "./PlaneIcon.vue?vue&type=template&id=805cb180&"
import script from "./PlaneIcon.vue?vue&type=script&lang=js&"
export * from "./PlaneIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports